var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof hhgDiscoverV2 !== "undefined") return resolve();
	__webpack_require__.l("https://preprod-hhg-discover-fe-v2.hellobacsi.com/_next/static/chunks/remoteEntry.js", function(event) {
		if(typeof hhgDiscoverV2 !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "hhgDiscoverV2");
}).then(function() { return hhgDiscoverV2; });